<template>
    <v-radio-group label="Reactants and/or products" v-model="value" @change="$emit('update:reaction-side', $event)">
        <template v-slot:label><slot></slot></template>
        <v-radio label="reactants" value="reactants"></v-radio>
        <v-radio label="products" value="products"></v-radio>
        <v-radio label="both" value="molecules"></v-radio>
    </v-radio-group>
</template>

<script>
export default {
    name: 'ReactionSideSelector',
    props: {
        reactionSide: String
    },
    data:
        function() {
            return {
                value: this.reactionSide
            }
        }
}
</script>